// src/pages/home/components/NavigationGrid.jsx
import React from "react";
import { motion } from "framer-motion";

const navLinks = [
  {
    label: "Hướng dẫn thủ tục",
    to: "/huong-dan-thu-tuc",
    icon: "/images/procedure.png",
  },
  {
    label: "Danh sách yêu cầu",
    to: "/danh-sach-yeu-cau",
    icon: "/images/tickets.png",
  },
  {
    label: "Danh sách hợp đồng",
    to: "/danh-sach-hop-dong",
    icon: "/images/contract.png",
  },
  {
    label: "Báo phí",
    to: "/bao-phi",
    icon: "/images/coin-hand.png",
  },
  { label: "Tài liệu", to: "/tai-lieu", icon: "/images/computer.png" },
  {
    label: "Mua bán sở hữu trí tuệ",
    to: "/mua-ban-so-huu-tri-tue",
    icon: "/images/computer.png",
  },
];

const NavigationGrid = () => {
  return (
    <div className="mt-3 grid grid-cols-3 gap-3 pb-[60px] md:grid-cols-4 lg:gap-4">
      {navLinks.map((item, index) => {
        const Tag = item.external ? "a" : "a";
        return (
          <Tag
            key={index}
            href={item.to}
            target={item.external ? "_blank" : "_self"}
            rel="noopener noreferrer"
            className="block"
          >
            <motion.div
              whileHover={{ y: -2, scale: 1.01 }}
              whileTap={{ scale: 0.98 }}
              className="flex aspect-square w-full flex-col items-center justify-center gap-2 rounded-[8px] border-[0.5px] border-[#010DC8] bg-white p-2 shadow-[0_0_2px_0_rgba(0,0,0,0.25)] transition-colors hover:bg-blue-50"
            >
              <img
                src={item.icon}
                alt=""
                className="size-[42px] object-contain sm:size-[46px] md:size-[50px] lg:size-[56px]"
                loading="lazy"
              />
              <span
                className="line-clamp-2 text-center font-sf-bold text-[13.5px] leading-tight text-black"
                style={{
                  fontFamily: '"SF Pro Display Bold", sans-serif',
                  fontWeight: 700,
                }}
              >
                {item.label}
              </span>
            </motion.div>
          </Tag>
        );
      })}
    </div>
  );
};

export default NavigationGrid;
